<template>
  <main class="OpenMarketCities">
    <HeaderImage />
    <HeaderText :city="city" />
    <CallToAction :city="city" />
    <StepsTitle :city="city" />
    <Steps :city="city" />
    <NetherlandsFormCTA />
    <FeaturesAndContactInfo />
  </main>
</template>

<script>
import {
  setMetaDescription,
  revertMetaDescription,
} from '../../../utils/netherlands/seo';
import StepsTitle from '../../components/netherlands/OpenMarketCities/StepsTitle.vue';
import Steps from '../../components/netherlands/OpenMarketCities/Steps.vue';
import HeaderImage from '../../components/netherlands/OpenMarketCities/HeaderImage.vue';
import CallToAction from '../../components/netherlands/OpenMarketCities/CallToAction.vue';
import HeaderText from '../../components/netherlands/OpenMarketCities/HeaderText.vue';
import NetherlandsFormCTA from '../../components/HomePage/NetherlandsFormCTA.vue';
import FeaturesAndContactInfo from '../../components/netherlands/OpenMarketCities/FeaturesAndContactInfo.vue';

export default {
  components: {
    Steps,
    HeaderImage,
    CallToAction,
    StepsTitle,
    NetherlandsFormCTA,
    HeaderText,
    FeaturesAndContactInfo,
  },
  name: 'OpenMarketCities',
  computed: {
    city() {
      return this.$route.params.name;
    },
  },
  beforeMount() {
    setMetaDescription(this.city);
  },
  beforeDestroy() {
    revertMetaDescription();
  },
};
</script>

<style scoped>
.OpenMarketCities >>> .parent {
  --global-open-market-margin: 1.2em;
}
@media (min-width: 768px) {
  .OpenMarketCities >>> .parent {
    --global-open-market-margin: 150px;
  }
}
</style>
